export default __webpack_public_path__ + "static/media/food_restriction.9b8508fe.png";